
type TytleProps = {text : string}

export const Title = (props: TytleProps) => {
    return <h2 style={{fontSize: "24px", fontWeight: "bold"}}>{props.text}</h2>
}